export type OrdinatoItem = {
	id: number;
	rental: string;
	account_id: string;
	contratto_id: string;
	targa: string;
	telaio: string;
	data_immatricolazione: null | string;
	marca: string;
	modello: string;
	allestimento: string;
	durata_contratto: string;
	km_contratto: string;
	inizio_contratto: null | string;
	fine_contratto: null | string;
	canone_totale: string;
	km_ultimo_rilevamento: null | string;
	data_ultimo_rilevamento: null | string;
	cliente: string;
	partita_iva: string;
	cf: string;
	stato: string;
	data_consegna: string;
	luogo_consegna: null | string;
	sf_titolare: string;
	sf_filiale: string;
	sf_nominativo: string;
	sf_piva: string;
	sf_cf: string;
};

export type CircolanteItem = {
	id: number;
	rental: string;
	account_id: string;
	contratto_id: string;
	targa: string;
	telaio: string;
	data_immatricolazione: null | string;
	marca: string;
	modello: string;
	allestimento: string;
	durata_contratto: string;
	km_contratto: string;
	inizio_contratto: string;
	fine_contratto: string;
	canone_totale: string;
	km_ultimo_rilevamento: string;
	data_ultimo_rilevamento: string;
	cliente: string;
	partita_iva: null | string;
	cf: null | string;
	stato: string;
	data_consegna: null | string;
	luogo_consegna: null | string;
	sf_titolare: string;
	sf_filiale: string;
	sf_nominativo: string;
	sf_piva: string;
	sf_cf: string;
};

export default class AccountExternalApi {
	static #baseUrl =
		process.env.NODE_ENV === 'development'
			? '/account-external-api/api'
			: `${process.env.REACT_APP_ACCOUNT_EXTERNAL_API_BASEURL}/api`;

	static #defaultHeaders = {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		Authorization: `Bearer ${process.env.REACT_APP_ACCOUNT_EXTERNAL_API_TOKEN}`,
	};

	static async ordinato(accountId: string): Promise<OrdinatoItem[]> {
		return fetch(`${this.#baseUrl}/${accountId}/ordinato`, {
			headers: this.#defaultHeaders,
		}).then((res) => {
			if (res.ok) return res.json();
			throw new Error(res.statusText);
		});
	}

	static async circolante(accountId: string): Promise<CircolanteItem[]> {
		return fetch(`${this.#baseUrl}/${accountId}/circolante`, {
			headers: this.#defaultHeaders,
		}).then((res) => {
			if (res.ok) return res.json();
			throw new Error(res.statusText);
		});
	}
}
